import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import breadcrumbs from './breadcrumbs'
import employee from './employee'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    breadcrumbs,
    employee
  }
})
